module.exports = "#append_wrapper>.row:first-child {display:none;}"